import { Alert, Button, Space, Typography } from 'antd';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import type { PlatformRoleDetail } from './platform-permission-types.js';

export function PlatformRoleMembersPanel({
  detail,
}: {
  detail: PlatformRoleDetail;
  onChanged: () => Promise<void> | void;
}) {
  const { t } = useTranslation('accessCenter');
  const navigate = useNavigate();

  return (
    <Space direction="vertical" size={8} style={{ width: '100%' }}>
      <Typography.Title level={5} style={{ marginTop: 24, marginBottom: 0 }}>
        {t('grantGovernance')}
      </Typography.Title>
      <Alert
        type="info"
        showIcon
        message={t('legacyMembersMoved')}
        description={t('legacyMembersMovedDescription', { count: detail.memberCount })}
        action={
          <Button
            type="primary"
            size="small"
            icon={<ArrowRight size={14} />}
            onClick={() => navigate('/app/admin/access-center?tab=assignments')}
          >
            {t('openAccess')}
          </Button>
        }
      />
    </Space>
  );
}
